/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState} from 'react'
import ReactModal from 'react-modal';
import EubSummarySection from '../../Pages/CartManagement/EubSummarySection'
import PlaceOrderSection from '../../Pages/MyOrders/ViewOrder/Components/PlacedOrderSection';
import { PriceHandler } from '../../redux/helper/CamelCase';
import { checkAssistant } from '../../redux/helper/CheckAssistant';
import DocumentModal from '../CartItemCard/DocumentModal';
import AcceptRejectBlock from './AcceptRejectBlock';
import AdorCashSection from './AdorCashSection';
import DistributorComments from './DistributorComments';
import OrderTabSummary from './OrderTabSummary'
import ProposeTabSummary from './ProposeTabSummary'
import RevisedSection from './RevisedSection';

function RevisedSummary({OrderData,
    setacceptRejectPopup,
    documentData,
    setdocument,
    setadorCashCheck,
    adorCashCheck,
    handleStatusApprove,
    Privilages,
    loader,setloader}) {
    const [tab, settab] = useState('order');
    const orderFlow ={
        order_type:'Trade EUB Order'
    }
    const [distributorCommentPopup, setdistributorCommentPopup] = useState(false)
    return (
        <div> <div className="lg:min-w-[30%] min-w-full lg:mt-0 mt-4 lg:ml-[26px]">
            <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                        {/* <!-- <p class="font-normal text-xs3 text-[#555259]">Total Order Qty.: 15,000 kg</p> --> */}
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]">Trade EUB Order</p>
                </div>
                <div className="mt-3 border-b border-[#CBCBCB]">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{OrderData && Number(OrderData?.order?.total_items||0)}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        <p className="font-normal text-sm text-[#555259]"> {OrderData&& Object(OrderData?.order?.summary).hasOwnProperty('quantity') && Object.keys(OrderData?.order?.summary?.quantity).length>0 && Object.keys(OrderData?.order?.summary?.quantity).map((UOM,i)=>(
                            <span style={{float: `${i===0?'':'right'}`}} key={UOM} className={`font-semibold`}>{Number(OrderData.order?.summary?.quantity[UOM])} {UOM} <br/></span>
                        ))}</p>
                    </div>
                </div>
                <div className="pt-1.5">
                    <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]" id="pills-tab" role="tablist">
                        <li onClick={()=>settab('order')} className="nav-item w-1/2 text-center" role="presentation">
                            <a href="javascript:void(0)" className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary ${tab==='order'?'active relative':''}`} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                                Proposed Summary
                            </a>
                        </li>
                        <li onClick={()=>settab('propose')}  className="nav-item w-1/2 text-center" role="presentation">
                            <a href="javascript:void(0)" className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary relative ${tab==='propose'?' active':''}`} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                                Revised Summary
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        
                        <div className="tab-pane fade show active px-1" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                            
                            {tab==='order'&&OrderData&& <PlaceOrderSection OrderData={OrderData?.order} 
                                setadorCashCheck={setadorCashCheck}
                                adorCashCheck={adorCashCheck}
                                type='order' Calculation={OrderData.order.summary} orderFlow="order" GetCalculation={()=>console.log('Draft')}/>}
                            {tab==='propose'&&OrderData&& <RevisedSection 
                                setadorCashCheck={setadorCashCheck}
                                OrderDetails={OrderData}
                                adorCashCheck={adorCashCheck}
                                type='order' Calculation={OrderData.order.summary} orderFlow="order" GetCalculation={()=>console.log('Draft')}/>}
                            
                        </div>
                    </div>
                </div>
                {/* <p className="font-normal text-xs3 text-[#FF3B30] mt-1.5"><span className="text-[#FF3B30]">*</span>Taxes & Duties are subject to change as per Government guidelines and will be charged as applicable at the time of dispatch</p> */}
                {/* <div className="flex justify-center items-center" onClick={()=>setdistributorCommentPopup(!distributorCommentPopup)}>
                    <p className="text-center text-sm font-semibold text-[#000000] py-4 pr-3 cursor-pointer" data-bs-toggle="modal" data-bs-target="#addDocumnetation">View Distributor Comments</p>
                    <img src="/images/Path-2635.svg" alt="icon" />
                </div>
                <ReactModal isOpen={distributorCommentPopup}>
                    <DocumentModal
                        setdocumentModal={setdistributorCommentPopup}
                        documentModal={distributorCommentPopup}
                        documentData={documentData}
                        setdocument={setdocument}
                        orderFlow={orderFlow}
                        loader={loader}
                        setloader={setloader}
                        handleSubmit={handleStatusApprove}
                        isdraft
                    />
                </ReactModal> */}
                {OrderData?.order?.work_flow_status==="3" && (OrderData?.order.status==="1" || OrderData?.order.status==="2") && !checkAssistant() &&
                <div className='pt-2'><AcceptRejectBlock setacceptRejectPopup={setacceptRejectPopup} distributor/></div>}
                <AdorCashSection OrderData={OrderData} key="revised_avail_ador_cash"/>
            </div>
            <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4" data-testid="eu-name-view">
                <p className="font-semibold text-base text-[#090406]">End User Customer Name</p>
                <div className="flex items-center mt-1">
                    {OrderData?.order?.eu_name ? (
                        <>
                            <span className="w-7 h-7 rounded-full bg-[#555259] text-white text-xs font-semibold flex items-center justify-center mr-2 flex-shrink-0">
                                {OrderData.order.eu_name.charAt(0).toUpperCase()}
                            </span>
                            <p className="font-normal text-sm text-[#555259]" data-testid="eu-name-value">{OrderData.order.eu_name}</p>
                        </>
                    ) : (
                        <p className="font-normal text-sm text-[#555259]" data-testid="eu-name-value">-</p>
                    )}
                </div>
            </div>
            <DistributorComments OrderData={OrderData}/>
        </div></div>
    )
}

export default RevisedSummary